<template>
  <div>
    <template v-for="item in menus">
      <MenuItem
        v-if="!item.childResourceList || !item.childResourceList.length"
        :key="item.id"
        :name="item.id"
        >
        <span class="iconfont" :class="iconConfig[item.name]" v-if="item.parentId === '0'" />
        <span :class="item.id === '130206' ? 'font12' : ''">{{ item.name }}</span></MenuItem
      >
      <template v-else>
        <Submenu :key="item.id" :name="item.id">
          <template #title>
            <span class="iconfont" :class="iconConfig[item.name]" v-if="item.parentId === '0'" />
            {{ item.name }}
          </template>
          <MyMenuItem :menus="item.childResourceList"></MyMenuItem>
        </Submenu>
      </template>
    </template>
  </div>
</template>
<script>
export default {
  name: 'MyMenuItem',
  props: {
    menus: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      iconConfig: {
        '首页': 'icon-shouye1',
        '数据管理': 'icon-outline-frame',
        '药材追溯': 'icon-mendian-yaocaiguanli-yaocaifenlei',
        '饮片追溯': 'icon-suyuan',
        '追溯赋码': 'icon-zhongzizhuisu',
        '系统管理': 'icon-shezhi',
        '后台管理': 'icon-zonghoutai-houtaiguanli',
        '工作台': 'icon-gongzuotai',
      }
    }
  }
}
</script>
<style scoped>
.font12 {
  /* font-size: 12px; */
}
</style>
